export default __webpack_public_path__ + "static/media/agro-logo.539da753.png";